<template>
  <section class="dashboard-outer">
    <router-link to="/" class="icon-container">
      <svg xmlns="http://www.w3.org/2000/svg" width="39" height="37" viewBox="0 0 39 37">
        <g fill="#f6b92f" fill-rule="evenodd">
            <path d="M3.246 1.267c-.283 0-.548.115-.75.329-.252.266-.343.623-.25.978l4.08 15.672-4.08 15.674c-.093.354-.002.71.25.978.251.266.601.378.96.308l16.564-3.273 16.563 3.272c.36.071.71-.04.961-.308.251-.267.343-.623.25-.978l-4.08-15.673 4.08-15.673c.093-.354.002-.71-.25-.977-.251-.267-.601-.38-.96-.308L20.02 4.56 3.457 1.288c-.071-.014-.141-.021-.21-.021m-1.674 34.5c-.548-.583-.756-1.393-.554-2.167l3.997-15.354L1.019 2.893c-.201-.774.006-1.584.554-2.166.55-.582 1.345-.837 2.13-.682L20.02 3.269 36.338.045c.784-.155 1.58.1 2.129.682.548.582.755 1.392.554 2.166l-3.997 15.353L39.02 33.6c.202.774-.005 1.584-.554 2.166-.548.583-1.344.837-2.129.682L20.02 33.224 3.702 36.45c-.15.03-.302.044-.453.044-.629 0-1.233-.257-1.676-.727z" transform="translate(-1)"/>
            <path d="M8.027 25.049l-1.572 6.1 6.819-.914.69-2.996h12.103l.691 2.996 6.819.913-1.572-6.1-2.95-.703-.017-6.089.018-6.084 2.95-.704 1.57-6.1-6.818.913-.691 2.997H13.965l-.691-2.997-6.819-.912 1.572 6.099 2.95.704.017 6.084-.018 6.09-2.95.703zm27.246 7.605l-9.552-1.28-.662-2.868H14.973l-.661 2.869-9.554 1.279 2.232-8.66 2.722-.65.015-5.088-.015-5.083-2.722-.65-2.232-8.66 9.554 1.279.661 2.868H25.06l.662-2.868 9.552-1.28-2.231 8.661-2.722.65-.015 5.085.015 5.086 2.722.65 2.231 8.66z" transform="translate(-1)"/>
            <path d="M24.068 19.41l-3.12 3.037h-1.893l-3.083-3.145v-2.178l3.079-3.078h1.872l3.145 3.082v2.282zm-2.628-6.63h-2.914l-3.82 3.82v3.22l3.816 3.894h2.94l3.873-3.768v-3.35l-3.895-3.817z" transform="translate(-1)"/>
            <path d="M20.4 20.003h-.793c-.058 0-.113-.024-.153-.066-.04-.041-.06-.097-.058-.155l.023-.492-.468-.467h-.481c-.117 0-.211-.095-.211-.211v-.725c0-.116.094-.211.21-.211h.509l.45-.45v-.524c0-.117.095-.211.211-.211h.816c.116 0 .21.094.21.21v.535l.424.424h.481c.117 0 .211.094.211.211v.746c0 .116-.094.211-.21.211h-.487l-.472.472v.492c0 .116-.094.21-.211.21" transform="translate(-1)"/>
        </g>
      </svg>
      <p>oh elvas</p>
    </router-link>
    <div :class="{'open': this.open}" class="sidebar">
      <section>
        <router-link @click.native="toggleMenu" to="/user/dashboard/informacao-pessoal">Informação Pessoal</router-link>
        <router-link @click.native="toggleMenu" to="/user/dashboard/alterar-password">Alterar Password</router-link>
        <router-link @click.native="toggleMenu" to="/user/dashboard/percursos-guardados">Percursos Guardados</router-link>
        <router-link @click.native="toggleMenu" to="/user/dashboard/favoritos">Favoritos</router-link>
        <elvas-button :button="{title: 'Logout'}" @click.native="logout()"></elvas-button>
      </section>
    </div>
    <div class="outer-page">
      <router-view></router-view>
    </div>

    <img v-if="widthSize <= 770" class="icon open-icon" :class="{'close': this.open}" @click="toggleMenu()" src="@/assets/menu-hamburger.svg"/>
    <img v-if="widthSize <= 770" class="icon close-icon" :class="{'open': this.open}" @click="toggleMenu()" src="@/assets/menu-close.svg"/>
  </section>
</template>
<script>
export default {
  data() {
    return {
      open: false,
      widthSize: null
    }
  },
  methods: {
    async logout () {
      this.$store.dispatch('logout')
      this.$router.push('/user/login')
      this.logged = false
      this.open = false
    },
    toggleMenu () {
      this.open = !this.open
    },
    getWindowWidth() {
      const clientWidtH = document.documentElement.clientWidth;
      if(clientWidtH > 770 && this.open){
        this.open = false
      }
      this.widthSize = clientWidtH
		}
  },
  mounted(){
    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowWidth);
    })

    this.getWindowWidth()
  },
  destroyed(){
    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowWidth);
    })
  }
}
</script>
<style lang="scss" scoped>
.dashboard-outer {
  display: flex;
  flex-grow: 1;

  @media (max-width: 770px){
    flex-direction: column;
  }
}
.icon-container {
  z-index: 2;
  position: absolute;
  top: 20px;
  left: 20px;
  display: flex;
  align-items: center;
  p {
    font-size: 24px;
    text-transform: uppercase;
    color: #f6b92f;
    font-weight: bold;
    margin-left: 20px;
    letter-spacing: -1.5px;
  }
}
.sidebar {
  background: #f6ede0;
  display: flex;
  align-items: center;
  position: fixed;
  height: 100vh;
  section {
    padding: 0 80px;
    display: flex;
    flex-direction: column;
    padding-bottom: 125px;
    a {
      font-size: 18px;
      font-weight: bold;
      line-height: 0.89;
      color: #f6b92f;
      opacity: 0.5;
      margin: 12px 0;
      &.router-link-exact-active {
        opacity: 1;
      }
    }
    .elvas-button {
      margin-top: 36px;
    }
  }

  @media (max-width: 770px){
    display: none;

    &.open {
      display: block;
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 5;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding-top: 32px;
      section {
        padding: 0 40px;
        display: flex;
        flex-direction: column;
        width: calc(100% - 80px);

        a {
          text-align: center;
          font-size: 22px;
        }
      }
    }

  }
}
.outer-page {
  padding-left: 340px;
  width: 100%;

  @media (max-width: 770px){
    padding: 0;
  }
}
</style>
<style lang="scss">
.dashboard-outer {
  h4 {
    font-size: 48px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.13;
    letter-spacing: -0.86px;
    color: #b0916b;
    margin-top: 120px;

    @media (max-width: 600px){
      font-size: 36px;
    }
  }
  .inner-page {
    padding: 0 80px;
    input {
      margin-top: 32px;
      display: block;
      min-width: 20vw;
    }
    .elvas-button {
      margin-top: 40px;
    }

    @media screen and (max-width: 600px){
      padding: 0 16px;
      input {
        min-width: 80vw;
      }
    }
  }

    img.icon {
    position: absolute;
    top: 35px;
    right: 35px;
    cursor: pointer;
    &.open-icon {
      z-index: 20;
      right: 16px;
      top: 16px;
      &.close {
        display: none;
      }
    }
    &.close-icon {
      position: fixed;
      z-index: 20;
      right: 16px;
      top: 16px;
      display: none;
      &.open {
        display: block;
      }
    }
  }
}
</style>